import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addAgencyPayment } from "common/services/payments.service";
import { toast } from "react-toastify";
import { extractFieldErrors } from "common/lib/fieldErrors";
import PaymentForm from "pages/Payments/PaymentForm";
import { useProfile } from "Components/Hooks/UserHooks";

const AddPayment: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);
  const { userProfile } = useProfile();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      projectOrFund: "",
      staffId: "",
      isSalaryAligned: false,
      amountPerMonth: "",
      startDate: "",
      endDate: "",
      paymentIdentifier: "",
      dataProvidedBy: "",
      positionTitle: "",
      individual: {
        value: "",
        label: "",
      },
      mda: {
        value: "",
        label: "",
      },
      agency: {
        value: userProfile?.agency?.id,
        label: userProfile?.agency?.name,
      },
      positionType: {
        value: "",
        label: "",
      },
      paymentCategory: {
        value: "",
        label: "",
      },
      thematicArea: {
        value: "",
        label: "",
      },
      sector: {
        value: "",
        label: "",
      },
    },
    validationSchema: Yup.object({
      projectOrFund: Yup.string().required("Please enter project or fund"),
      staffId: Yup.string(),
      amountPerMonth: Yup.number().required("Please enter amount per month"),
      startDate: Yup.string().required("Please enter start date"),
      endDate: Yup.string().required("Please enter end date"),
      // paymentIdentifier: Yup.string().required(
      //   "Please enter payment identifier"
      // ),
      dataProvidedBy: Yup.string().required("Please enter data provided by"),
      positionTitle: Yup.string().required("Please enter position title"),
      individual: Yup.object().shape({
        value: Yup.number().required("Please select individual"),
      }),
      mda: Yup.object().shape({
        value: Yup.number().required("Please select MDA"),
      }),
      region: Yup.object().shape({
        value: Yup.number().required("Please select region"),
      }),
      agency: Yup.object().shape({
        value: Yup.number().required("Please select agency"),
      }),
      positionType: Yup.object().shape({
        value: Yup.number().required("Please select position type"),
      }),
      paymentCategory: Yup.object().shape({
        value: Yup.number().required("Please select payment category"),
      }),
      thematicArea: Yup.object().shape({
        value: Yup.number().nullable(),
      }),
      sector: Yup.object().shape({
        value: Yup.number().nullable(),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          individual: values.individual?.value || null,
          mda: values.mda?.value || null,
          agency: userProfile?.agency?.id || null,
          positionType: values.positionType?.value || null,
          paymentCategory: values.paymentCategory?.value || null,
          projectOrFund: values.projectOrFund,
          staffId: values.staffId,
          isSalaryAligned: values.isSalaryAligned,
          amountPerMonth: values.amountPerMonth,
          startDate: values.startDate || null,
          endDate: values.endDate || null,
          // paymentIdentifier: values.paymentIdentifier,
          dataProvidedBy: values.dataProvidedBy,
          positionTitle: values.positionTitle,
          thematicArea: values.thematicArea?.value || null,
          sector: values.sector?.value || null,
        },
      };

      setLoading(true);
      try {
        await addAgencyPayment(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Payment added successfully", {});
      } catch (e: any) {
        const errors = extractFieldErrors(e?.response);
        setFieldErrors(errors);
        toast.error("Payment creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="xl"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Payment
      </ModalHeader>

      <PaymentForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
        fieldErrors={fieldErrors}
      />
    </Modal>
  );
};

export default AddPayment;
